import z from 'zod'

import { getHashFromString } from '@/legacy-src/utilities/codingPublicHash'

import { fetchStrapiApp } from '@/src/domains/strapi/services/fetchStrapiApp'

const PromotionsBarSchema = z.object({
  content: z.string().optional(),
  isVisible: z.boolean().optional(),
})

const Schema = z.object({
  businessPromotionsBar: PromotionsBarSchema.nullish(),
  promotionsBar: PromotionsBarSchema.nullish(),
})

export const fetchPromotionsBar = async ({ isBusinessPage }: { isBusinessPage?: boolean }) => {
  const type = isBusinessPage ? 'businessPromotionsBar' : 'promotionsBar'

  try {
    const data = await fetchStrapiApp({
      query: {
        populate: {
          [type]: {
            populate: '*',
          },
        },
      },
      schema: Schema,
    })

    return {
      content: data?.[type]?.content ?? '',
      isVisible: data?.[type]?.isVisible ?? false,
    }
  } catch (_) {
    return {
      content: '',
      isVisible: false,
    }
  }
}

export const getPromotionsBarCacheKey = (isBusinessPage: boolean) => {
  return [`promoBar-${isBusinessPage ? 'business' : 'public'}`, isBusinessPage]
}

export const getPromotionsBarCookieName = (promoText: string) => 'hidePromo' + getHashFromString(promoText)
